import type { FC } from 'react';

import { SECTION_IDS } from '@/features/home/constants/home.constants';
import type { HowItWorksStep } from '@/types/home.types';

interface HowItWorksSectionProps {
  steps: HowItWorksStep[];
}

const HowItWorksSection: FC<HowItWorksSectionProps> = ({ steps }) => (
  <section id={SECTION_IDS.howItWorks} className="scroll-mt-20 bg-white">
    <div className="mx-auto w-full max-w-6xl px-5 py-20 md:px-8">
      <header className="max-w-2xl">
        <h2 className="font-display text-3xl font-extrabold text-[var(--color-ink)] md:text-4xl">
          How Shoutt works
        </h2>
        <p className="mt-4 text-base leading-relaxed text-[var(--color-ink-muted)]">
          Three steps from “I need this by Friday” to it being in your hands.
        </p>
      </header>

      <ol className="mt-12 grid gap-6 md:grid-cols-3">
        {steps.map((step) => (
          <li
            key={step.step}
            className="flex flex-col gap-4 rounded-3xl border border-[var(--color-divider)] bg-[var(--color-surface-muted)] p-7"
          >
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-500 font-display text-base font-bold text-white">
              {step.step}
            </span>
            <h3 className="font-display text-xl font-bold text-[var(--color-ink)]">{step.title}</h3>
            <p className="text-sm leading-relaxed text-[var(--color-ink-muted)]">{step.body}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorksSection;
